import { NgModule } from '@angular/core';
import { TranslatePipe } from './translate/translate.pipe';
import { TranslatePlaceholderPipe } from './translate/translatePlaceholder.pipe';
import { UserDatePipe } from './date-time/user-date.pipe';
import { EnumListPipe } from './enum-list/enum-list.pipe';
import { TranslationService } from '../services/translation.service';
import { TruncatePipe } from './truncate/truncate.pipe';
import { UserDateTimePipe } from './date-time/user-date-time-pipe';
import { TooltipTextPipe } from './tooltip-text/tooltip-text.pipe';

@NgModule({
    declarations: [TranslatePlaceholderPipe, TranslatePipe, UserDatePipe,UserDateTimePipe, EnumListPipe, TruncatePipe, TooltipTextPipe],
    exports: [TranslatePlaceholderPipe, TranslatePipe, UserDatePipe,UserDateTimePipe, EnumListPipe, TruncatePipe, TooltipTextPipe],
    providers: [TranslationService]
})

export class PipeModule {
    constructor() { }
}
